import { Injectable } from '@angular/core';
import { map, pluck } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { Client, EventMessageComponent } from '@app/shared';
import { HttpClient } from '@angular/common/http';
import { ScheduledBonuse } from '@app/driver-tariffs/_models/scheduled-bonuse';
import { MatSnackBar } from '@angular/material';

@Injectable()
export class ScheduledBonusesService {
  selectedServiceId: number;
  products = [];
  bonuses$ = new Subject<ScheduledBonuse[]>();
  private scheduledBonuses: ScheduledBonuse[];

  constructor(private http: HttpClient, private client: Client, private snackBar: MatSnackBar) {}

  fetchBonusesByService(service): void {
    this.getAllScheduledBonecesByService(service)
      .pipe(map(res => [...res['data']]))
      .subscribe(bonuses => {
        this.scheduledBonuses = bonuses;
        this.bonuses$.next([...this.scheduledBonuses]);
      });
    this.http.get(this.client.getProductsUrl()).subscribe((res: any) => {
      this.products = res.data.filter(product => product.service_id == service);
    });
  }

  fethRmoveBonuse(id: string) {
    this.removeScheduledBonuse(id).subscribe((isRmove: boolean) => {
      this.scheduledBonuses = this.scheduledBonuses.filter(el => el.id !== id);
      this.bonuses$.next([...this.scheduledBonuses]);
    });
  }

  fetchCreateUpdateBonuice(obj: ScheduledBonuse) {
    if (obj.id) {
      this.updateScheduledBonuse(obj).subscribe((bonuse: ScheduledBonuse) => {
        this.handleEvent('BONUS_SAVED');
        this.scheduledBonuses = this.scheduledBonuses.map(el => {
          if (el.id === bonuse.id) {
            return bonuse;
          } else {
            return el;
          }
        });
        this.bonuses$.next([...this.scheduledBonuses]);
      });
    } else {
      const newBonuse: ScheduledBonuse = obj;
      delete newBonuse.id;
      this.createScheduledBonuse({ ...newBonuse, service_id: this.selectedServiceId.toString() }).subscribe(
        (bonuse: ScheduledBonuse) => {
          this.handleEvent('BONUS_CREATED');
          this.scheduledBonuses.push(bonuse);
          this.bonuses$.next([...this.scheduledBonuses]);
        }
      );
    }
  }

  private handleEvent(msg) {
    this.snackBar.openFromComponent(EventMessageComponent, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        message: msg
      }
    });
  }

  private getAllScheduledBonecesByService(serviceId) {
    return this.http.get(this.client.getScheduledBonusesUrl({ service: serviceId }));
  }

  private createScheduledBonuse(body: ScheduledBonuse): Observable<any> {
    return this.http.post(this.client.getScheduledBonusesUrl(), body).pipe(pluck('data'));
  }

  private updateScheduledBonuse(body: ScheduledBonuse): Observable<any> {
    return this.http.put(this.client.getScheduledBonusesUrl(), body).pipe(pluck('data'));
  }

  private removeScheduledBonuse(bonuseId: string) {
    return this.http.request('DELETE', this.client.getScheduledBonusesUrl(), { body: { id: bonuseId } });
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/services/scheduled-bonuses.service.ts